export default "__VITE_ASSET__DRmWCeNg__"